export default __webpack_public_path__ + "static/media/product-detail-04.e265218d.jpg";